import { inject } from '@angular/core';
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { WINDOW } from '../../providers/window/window.provider';
import { Env } from '../web-config/web-config.helper';
import { WebConfigService } from '../web-config/web-config.service';

import { Service } from '@angular/core';

@Service()
export class LoggerProviderService {
  #webconfig = inject(WebConfigService);
  #logger = inject(NGXLogger);
  #window = inject(WINDOW);

  constructor() {
    this.setLogLevel();
  }

  setLogLevel() {
    const urlSearchParams = new URLSearchParams(this.#window.location.search);
    const viewLogs = urlSearchParams.get('logs') === 'true' || this.#window.sessionStorage.getItem('logs') === 'true';
    let level: NgxLoggerLevel;
    const isQa = this.#window.location?.host.endsWith('.qa.haloplus.io');
    if (this.#webconfig.env === Env.Qa || (!this.#webconfig.env && isQa)) {
      level = viewLogs ? NgxLoggerLevel.DEBUG : NgxLoggerLevel.OFF;
      this.#logger.updateConfig({ level });
    }
  }
}
